/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class OnLoadFilterModifierAPI
 * @hideconstructor
 * @classdesc API class that is used to apply dashboard drill
 */
define(() => {
	class OnLoadFilterModifierAPI {
		/**
		 * @function OnLoadFilterModifierAPI#getMetadataSubsetIds
		 * @description get the metadataSubsetIds contributed by this feature
		 * @return {Array} metadataSubsetIds
		 */
		getMetadataSubsetIds() {}
	}
	return OnLoadFilterModifierAPI;
});
